/**
 * Wrapper para Vapor.store que envia o filename na requisição
 * Preserva o nome original do arquivo para melhor SEO
 */
function vaporStoreWithFilename(file, options = {}) {
    const fileName = file.name;
    const baseURL = options.baseURL || siteUrl("/painel");
    const progressCallback = options.progress;
    
    // Fazer requisição manual para obter URL assinada com filename
    return fetch(`${baseURL}/vapor/signed-storage-url`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '',
        },
        body: JSON.stringify({
            filename: fileName,
            content_type: file.type,
        })
    })
    .then(response => response.json())
    .then(data => {
        // Fazer upload do arquivo para a URL assinada com suporte a progress
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            
            // Monitorar progresso do upload
            if (progressCallback) {
                xhr.upload.addEventListener('progress', (e) => {
                    if (e.lengthComputable) {
                        const percentComplete = e.loaded / e.total;
                        progressCallback(percentComplete);
                    }
                });
            }
            
            xhr.addEventListener('load', () => {
                if (xhr.status >= 200 && xhr.status < 300) {
                    // Retornar resposta no formato esperado pelo Vapor.store
                    resolve({
                        uuid: data.uuid,
                        key: data.key,
                        bucket: data.bucket
                    });
                } else {
                    reject(new Error(`Upload failed with status ${xhr.status}`));
                }
            });
            
            xhr.addEventListener('error', () => {
                reject(new Error('Upload failed'));
            });
            
            xhr.open('PUT', data.url);
            
            // Adicionar headers da resposta (ignorar headers proibidos pelo browser)
            Object.keys(data.headers || {}).forEach(key => {
                if (key.toLowerCase() === 'host') {
                    return;
                }
                xhr.setRequestHeader(key, data.headers[key]);
            });
            
            xhr.send(file);
        });
    });
}

module.exports = { vaporStoreWithFilename };

